import React from 'react';
import { SubmitThankYouMessage } from './submit-thank-you-message';
import { SubmitErrorMessage } from './submit-error-message';
import { FadeOut } from './fade-out';
import { useSubmitStatus } from '../../contexts/submit-status-context';
export const SubmitStatusMessage = () => {
    const { submitSuccessMessage, submitFailureCode, submitFailureMessage } = useSubmitStatus();
    return (React.createElement(React.Fragment, null,
        React.createElement(FadeOut, { visible: !!submitSuccessMessage },
            React.createElement(SubmitThankYouMessage, { messageText: submitSuccessMessage })),
        React.createElement(SubmitErrorMessage, { errorMessageCode: submitFailureCode, errorMessage: submitFailureMessage })));
};
//# sourceMappingURL=submit-status-message.js.map